import { formatDate } from 'date-fns/format';
import useFindUsersQuery from '@/api/queries/useFindUsersQuery';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import Pagination from '@/components/Pagination';
import { SearchProps } from '@/components/search/useSearch';
import StatusActiveIndicator from '@/components/StatusActiveIndicator';
import { isStatusActive } from '@/models/Status';
import { formatUserRole } from '@/models/User';
import { UserEditPath } from '@/modules/admin/paths';
import { Link } from 'react-router-dom';

const UserTable = ({ searchQuery, page = 1, onChangePage = () => {} }: SearchProps) => {
  const { users, isLoading, itemsPerPage } = useFindUsersQuery(page, searchQuery);

  return (
    <div className="table-container">
      <div className="table-wrapper">
        <table className={isLoading ? 'loading' : ''}>
          <thead>
            <tr>
              <th>Username</th>
              <th>Name</th>
              <th>Role</th>
              <th>Created At</th>
              <th>Last Sign In At</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {users.items.map((user, index) => {
              if (user.id === undefined) {
                return null;
              }
              return (
                <tr key={index}>
                  <td>
                    <Link
                      to={UserEditPath.withId(user.id)}
                      className="text-blue-500 hover:underline"
                    >
                      {user.username}
                    </Link>
                  </td>
                  <td>{user.fullName}</td>
                  <td>{formatUserRole(user.role)}</td>
                  <td>{user.createdAt && formatDate(user.createdAt, 'd MMM yyyy')}</td>
                  <td>{user.lastSignInAt && formatDate(user.lastSignInAt, 'd MMM yyyy')}</td>
                  <td>
                    <StatusActiveIndicator isActive={isStatusActive(user)} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {isLoading && (
          <div role="status" className="loader">
            <SpinnerIcon />
            <span className="sr-only">Loading...</span>
          </div>
        )}
      </div>
      <div className="table-bottom">
        <Pagination
          currentPage={page}
          itemsPerPage={itemsPerPage}
          totalCount={users.totalCount || 0}
          estimatedTotalCount={users.estimatedTotalCount || 0}
          onClick={onChangePage}
        />
      </div>
    </div>
  );
};

export default UserTable;
